import React, { useMemo } from "react";

import { withTranslation } from "hoc/WithTranslation";
import m from "definedMessages";
import CommonTable from "components/Payments/CommonPaymentsTable";

const PaymentsListTable = ({
    data = [],
    loading = false,
    currencyName,

    formatMessage
}) => {

    const columns = useMemo(() => ([
        {
            id: "amount",
            label: formatMessage(m.amount),
            value: ({ sum }) => `${sum}${currencyName ? ` ${currencyName}` : ""}`,
            flexGrow: 2,
            minWidth: 200,
            align: "center",
        },
        {
            id: "date",
            label: formatMessage(m.date),
            dataKey: "date",
            flexGrow: 2,
            minWidth: 200,
            align: "center",
        },
        {
            id: "paymentDetails",
            label: formatMessage(m.paymentDetails),
            dataKey: "bank_detail",
            flexGrow: 2,
            minWidth: 200,
            align: "center",
        },
        {
            id: "service",
            label: formatMessage(m.service),
            dataKey: "service",
            flexGrow: 2,
            minWidth: 150,
            width: 287,
            align: "center",
        },
    ]), [currencyName, formatMessage]);

    return (
        <CommonTable
            data={data}
            loading={loading}
            columns={columns}
        />
    );
};

export default withTranslation(PaymentsListTable);
